// extracted by mini-css-extract-plugin
module.exports = {"bg_adder":"bgadder_bg_adder__3U4Fo"};